var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPosilinkBannerLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 26.334,
    viewBox: "0 0 120 26.334",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_487",
    "data-name": "Group 487",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_486",
    "data-name": "Group 486",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_488",
    "data-name": "Group 488",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_886",
    "data-name": "Path 886",
    d: "M351.524.847l-.95,2.716h4.8l.951-2.716Z",
    transform: "translate(-247.56 -0.847)",
    fill: "#0c4884"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_887",
    "data-name": "Path 887",
    d: "M387.284.847l-.951,2.716h4.8l.951-2.716Z",
    transform: "translate(-273.18 -0.847)",
    fill: "#0c4884"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_888",
    "data-name": "Path 888",
    d: "M174.287,0c-.346.926-.368,1.134-.982,2.891-.653,1.888-3.481,10.271-3.481,10.271-.6,1.756.361,2.649,2.925,2.649h8.21l1.173-3.355h-8.3L178.021,0",
    transform: "translate(-119.287)",
    fill: "#0c4884"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_889",
    "data-name": "Path 889",
    d: "M13.869,3.546l-1.6,4.666H6.446L8.059,3.546ZM14.822.393H5.3L0,15.948H3.658l1.553-4.5c.072,0,6.111.006,6.111.006,2.367,0,3.835-.99,4.421-2.67l1.885-5.315h0c.048-.139.1-.276.143-.406.613-1.754-.384-2.67-2.948-2.67",
    transform: "translate(0 -0.276)",
    fill: "#0c4884"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_890",
    "data-name": "Path 890",
    d: "M153.378,11.014h3.734l-4.234,12.4h-3.659Z",
    transform: "translate(-104.919 -7.744)",
    fill: "#0c4884"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_891",
    "data-name": "Path 891",
    d: "M116.58,11.014h-9.432q-3.847,0-4.767,2.634l-.037.121-.829,2.427c-.547,1.566.221,2.572,2.718,2.629l.005.008h5.941l-.438,1.247-9.614,0L98.95,23.417h9.858c2.367,0,3.837-1.049,4.424-2.729l.811-2.39c.614-1.755-.383-2.635-2.947-2.635h0l-5.728,0,.5-1.386h9.595Z",
    transform: "translate(-69.574 -7.744)",
    fill: "#0c4884"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_892",
    "data-name": "Path 892",
    d: "M64.049,14.288l-2,5.809H56.226l2.013-5.809Zm.989-3.274H59.465q-3.845,0-4.765,2.635c-.467,1.35-.471,1.35-2.411,7.073-.6,1.756.384,2.695,2.949,2.695H61.1c2.355,0,3.864-1.049,4.45-2.729,0,0,2.385-6.873,2.431-7.005.589-1.736-.38-2.669-2.944-2.669",
    transform: "translate(-36.646 -7.744)",
    fill: "#0c4884"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_893",
    "data-name": "Path 893",
    d: "M224.384,25.949l1.046-14.93,6.061,18.974-55.779-4.33Z",
    transform: "translate(-123.547 -7.748)",
    fill: "#0c4884"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_894",
    "data-name": "Path 894",
    d: "M200.422,11.015l9.322,15.035-3.858-.007,1.54,4.658-67.281-4.816,70.323,8.193,8.072-23.064Z",
    transform: "translate(-98.54 -7.744)",
    fill: "#4ccbfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_895",
    "data-name": "Path 895",
    d: "M218.148,10.787h3.734l-4.234,12.541h-3.659Z",
    transform: "translate(-150.461 -7.585)",
    fill: "#0c4884"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_896",
    "data-name": "Path 896",
    d: "M245.67,10.787l-2.476,7.465-2.476-7.465H236.9l-4.16,12.541H236.4l2.408-7.133,2.408,7.133h3.952L249.4,10.787Z",
    transform: "translate(-163.647 -7.585)",
    fill: "#0c4884"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_897",
    "data-name": "Path 897",
    d: "M297.588,10.787h-3.409a.626.626,0,0,0-.4.126l-6.42,4.794,1.569-4.7a.134.134,0,0,0-.053-.153.335.335,0,0,0-.213-.063h-3.036a.4.4,0,0,0-.226.063.282.282,0,0,0-.12.153l-3.86,12.177a.133.133,0,0,0,.053.153.334.334,0,0,0,.213.063h3.036a.394.394,0,0,0,.226-.063.28.28,0,0,0,.12-.153l1.052-3.5.073-.237,1.834-1.381a.188.188,0,0,1,.107-.036.093.093,0,0,1,.08.036l3.648,5.188q.08.144.346.144h3.408c.177,0,.266-.048.266-.144a.184.184,0,0,0-.027-.108l-4.846-6.827q-.053-.054.053-.126l6.684-5.134c.071-.048.107-.1.107-.144,0-.084-.089-.126-.266-.126",
    transform: "translate(-197.87 -7.585)",
    fill: "#0c4884"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosilinkBannerLogo);
export default __webpack_public_path__ + "static/media/posilinkBannerLogo.1aa27b7fd2ed95481ef9fdcca02bfb58.svg";
export { ForwardRef as ReactComponent };